export const ru = {
    selected_tariff: 'Выбранный тариф',
    continue: 'Продолжить',
    group_trip_info: 'Перейти к выбору участников заявки, которым нужно добавить данную услугу',
    tariff: 'Ваш тариф',
    person_trip_info: 'Перейти на страницу персональной заявки',
};
